<template>
  <div class="wrap_xszn">
    <v-tabs :menus="menus" ></v-tabs>
    <div class="xszn_main">
      <router-view/>
    </div><!--xszn_main-->
  </div>
</template>
<script>
import vTabs from '../../components/tabs.vue';

export default {
  name: 'xszn',
  components: {
    vTabs,
  },
  data() {
    return {
      menus: [
        { name: '如何购买', path: '/xszn/rhgm', className: 'xszn_tabs_p1' },
        { name: '新手引导', path: '/xszn/xsyd', className: 'xszn_tabs_p2' },
      ],
    };
  },
};
</script>
